import { render } from "./update_user.vue?vue&type=template&id=12ab3b80&scoped=true"
import script from "./update_user.vue?vue&type=script&lang=js"
export * from "./update_user.vue?vue&type=script&lang=js"

import "./update_user.vue?vue&type=style&index=0&id=12ab3b80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ab3b80"]])

export default __exports__